import { LinearProgress } from "@/components/progress";
import { BoardData } from "../schema/price-board.schema";
import { BoardTableCard } from "./board/BoardTableCard";
import { Box } from "@chakra-ui/react";
import { NoData } from "@/components/common/section-components/NoData";

interface Props {
  loadingPrices: boolean;
  sectionData?: BoardData;
}

export const BoardTable = ({ loadingPrices, sectionData }: Props) => {
  return loadingPrices ? (
    <LinearProgress />
  ) : (
    <>
      {!loadingPrices && Boolean(!sectionData?.pizarra?.length) && (
        <Box marginTop="30px">
          <NoData />
        </Box>
      )}
      {!loadingPrices && Boolean(sectionData?.pizarra?.length) && (
        <BoardTableCard sectionData={sectionData} />
      )}
    </>
  );
};
